__turbopack_context__.v({
  "agreement_box": "AgreementBox-module-scss-module__sPgJXW__agreement_box",
  "agreement_button": "AgreementBox-module-scss-module__sPgJXW__agreement_button",
  "agreement_item": "AgreementBox-module-scss-module__sPgJXW__agreement_item",
  "agreement_list": "AgreementBox-module-scss-module__sPgJXW__agreement_list",
  "agreement_text": "AgreementBox-module-scss-module__sPgJXW__agreement_text",
  "all_agree": "AgreementBox-module-scss-module__sPgJXW__all_agree",
  "all_agree_label": "AgreementBox-module-scss-module__sPgJXW__all_agree_label",
  "info": "AgreementBox-module-scss-module__sPgJXW__info",
  "main": "AgreementBox-module-scss-module__sPgJXW__main",
});
